export default {
  slaMonitor: { id: 'sla_monitor' },
  slaMonitorTitle: { id: 'sla_monitor_title' },
  slaTitle: { id: 'sla_title' },
  weatherTitle: { id: 'weather_forecast' },
  currentDirection: { id: 'current_direction' },
  selectReport: { id: 'select_report' },
  historyLogbook: { id: 'logbook_history' },
  feedAmount: { id: 'feed_amount' },
  actualExpected: { id: 'actual_vs_expected' },
  observedExpected: { id: 'observed_vs_expected' },
  daysLeftFeeding: { id: 'days_left_feeding' },
  diet: { id: 'diet' },
  positiveEnvironmentWindow: { id: 'positive_env_window' },
  oxygen: { id: 'oxygen' },
  temperature: { id: 'temperature' },
  current: { id: 'current' },
  tide: { id: 'tide' },
  feed: { id: 'feed' },
  environment: { id: 'environment' },
  viewDetails: { id: 'view_details' },
  chooseReport: { id: 'choose_report' },
  date: { id: 'date' },
  feedKg: { id: 'feed_kg' },
  time: { id: 'time' },
  submit: { id: 'submit' },
  update: { id: 'update_sla' },
  create: { id: 'create_sla' },
  logbookHistory: { id: 'logbook_history' },
  cage: { id: 'cage' },
  status: { id: 'status' },
  completed: { id: 'completed' },
  logged: { id: 'logged' },
  rate: { id: 'rate' },
  removeEntry: { id: 'remove_entry' },
  deleteLog: { id: 'delete_log' },
  deleteLogMessage: { id: 'delete_log_message' },
  feedUsed: { id: 'feed_used' },
  expected: { id: 'expected' },
  hour: { id: 'hour' },
  totalFeedUsed: { id: 'total_feed_used' },
  cages: { id: 'cages' },
  totalVisits: { id: 'total_visits' },
  avgDuration: { id: 'avg_duration' },
  actualVsExpected: { id: 'actual_vs_expected' },
  actual: { id: 'actual' },
  sfrObserved: { id: 'sfr_observed' },
  sfrExpected: { id: 'sfr_expected' },
  sfrCorrected: { id: 'sfr_corrected' },
  sfr: { id: 'sfr' },
  days: { id: 'days' },
  byTheHour: { id: 'by_the_hour' },
  lastFiveDays: { id: 'last_five_days' },
  byTheDay: { id: 'by_the_day' },
  lastSevenDays: { id: 'last_seven_days' },
  feedRemaining: { id: 'feed_remaining' },
  silos: { id: 'silos' },
  dayLeftFeeding: { id: 'day_left_feeding' },
  totalRemaining: { id: 'total_remaining' },
  dailyFeedUsed: { id: 'daily_feed_used' },
  oxygenMg: { id: 'oxygen_mg' },
  waterTemperature: { id: 'water_temperature' },
  saturation: { id: 'saturation' },
  siteLevel: { id: 'site_level' },
  weather_tide: { id: 'weather_tide' },
  weather_temperature: { id: 'weather_temperature' },
  weather_windSpeed: { id: 'weather_windSpeed' },
  weather_windDirection: { id: 'weather_windDirection' },
  sensor_saturation: { id: 'sensor_saturation' },
  sensor_oxygen: { id: 'sensor_oxygen' },
  sensor_temperature: { id: 'sensor_temperature' },
  sensor_speed: { id: 'sensor_speed' },
  now: { id: 'now' },
  high: { id: 'high' },
  low: { id: 'low' },
  min: { id: 'min' },
  max: { id: 'max' },
  lastUpdate: { id: 'last_update' },
  sensor: { id: 'sensor' },
  weather: { id: 'weather' },
  back: { id: 'back' },
  backToSite: { id: 'back_to_site' },
  corrected: { id: 'corrected' },
  last12Days: { id: 'last_12_days' },
  comment: { id: 'comment' },
  value: { id: 'value' },
  total: { id: 'total' },
  percentOfExpected: { id: 'percent_of_expected' },
  subtotal: { id: 'subtotal' },
  feeding: { id: 'feeding' },
  remaining: { id: 'remaining' },
  daysRemaining: { id: 'days_remaining' },
  remainingFeed: { id: 'remaining_feed' },
  avgDaily: { id: 'avg_daily' },
  daysLeft: { id: 'days_left' },
  user: { id: 'user' },
  sla: { id: 'sla' },
  currentBy: { id: 'current_by' },
  addComment: { id: 'add_comment' },
  unavailableDataMessage: { id: 'sensor_unavailable_message' },
  chooseComment: { id: 'choose_comment' },
  typeComment: { id: 'type_comment' },
}
